import * as types from './actionTypes';

// Fetch Claim Dropdown Lists
export const fetchClaimDropdown = (unit_id) => ({
  type: types.FETCH_CLAIM_DROPDOWN_REQUEST,
  payload: { unit_id },
});

export const saveExtraDutyClaim = (payload) => ({
  type: types.SAVE_EXTRA_DUTY_CLAIM_REQUEST,
  payload,
});

// Save Extra Duty Approvals
export const saveExtraDutyApproval = (payload) => ({
  type: types.SAVE_EXTRA_DUTY_APPROVAL_REQUEST,
  payload,
});

// Get Extra Duty Approval Detail List
export const fetchExtraDutyApprovalDetailList = (payload) => ({
  type: types.FETCH_EXTRA_DUTY_APPROVAL_DETAIL_LIST_REQUEST,
  payload,
});

// Get Extra Duty Approvals (list)
export const fetchExtraDutyApprovals = (payload) => ({
  type: types.FETCH_EXTRA_DUTY_APPROVALS_REQUEST,
  payload,
});

export const fetchPunchDetailsRequest = (payload) => ({
  type: types.FETCH_PUNCH_DETAILS_REQUEST,
  payload: payload,
});

// Save Extra Duty Cancel
export const saveExtraDutyCancel = (payload) => ({
  type: types.SAVE_EXTRA_DUTY_CANCEL_REQUEST,
  payload,
});

// Get Extra Duty Cancel Detail List
export const fetchExtraDutyCancelDetailList = (payload) => ({
  type: types.FETCH_EXTRA_DUTY_CANCEL_DETAIL_LIST_REQUEST,
  payload,
});

// Get Extra Duty Cancels (list)
export const fetchExtraDutyCancels = (payload) => ({
  type: types.FETCH_EXTRA_DUTY_CANCELS_REQUEST,
  payload,
});

export const fetchExtraDutyPaymentClaimList = (payload) => ({
  type: types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_LIST_REQUEST,
  payload,
});

export const convertPayment = (payload) => ({
  type: types.CONVERT_PAYMENT_REQUEST,
  payload,
});

// ✅ Get Approval List
export const fetchExtraDutyPaymentClaimApprovalList = (payload) => ({
  type: types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_APPROVAL_LIST_REQUEST,
  payload,
});

// ✅ Get Cancel List
export const fetchExtraDutyPaymentClaimCancelList = (payload) => ({
  type: types.FETCH_EXTRA_DUTY_PAYMENT_CLAIM_CANCEL_LIST_REQUEST,
  payload,
});

// ✅ Cancel Payment
export const cancelPayment = (payload) => ({
  type: types.CANCEL_PAYMENT_REQUEST,
  payload,
});

// ✅ Fetch Manual Punch List
export const fetchManualPunchList = (payload) => ({
  type: types.FETCH_MANUAL_PUNCH_LIST_REQUEST,
  payload,
});

// ✅ Save Manual Punch
export const saveManualPunch = (payload) => ({
  type: types.SAVE_MANUAL_PUNCH_REQUEST,
  payload,
});

// ✅ Delete Manual Punch
export const deleteManualPunch = (payload) => ({
  type: types.DELETE_MANUAL_PUNCH_REQUEST,
  payload,
});